import axios from "axios";
import { getLocation } from "../utils/location";

class ImageService {
    defaultProductImage = "resources/public/img/nophoto.png"
    defaultProductImageThumb = "resources/public/img/nophoto.thumb.png"

    getProdutoImages(produto: any): { img: string; thumb: string }[] {
        const cli = getLocation()

        const imagens = [] as { img: string; thumb: string }[]
        for (const image of produto?.imagens) {
            const basePath = `resources/${cli}/produtos`

            imagens.push({
                img: `${axios.defaults.baseURL}/${basePath}/${image?.url}`,
                thumb: `${axios.defaults.baseURL}/${basePath}/thumbs/${image?.url}`,
            })

        }

        if(!imagens.length){
            imagens.push({
                img: `${axios.defaults.baseURL}/${this.defaultProductImage}`,
                thumb: `${axios.defaults.baseURL}/${this.defaultProductImageThumb}`,
            })
        }

        return imagens;
    }

    makeBannerImageURL(bannerName: string) {
        const cli = getLocation();

        return {
            img: `${axios.defaults.baseURL}/resources/${cli}/banners/${bannerName}`,
            thumb: `${axios.defaults.baseURL}/resources/${cli}/banners/thumbs/${bannerName}`,
        };
    }

    makeLogoImageURL(logoName: string) {
        const cli = getLocation();

        return {
            img: `${axios.defaults.baseURL}/resources/${cli}/logo/${logoName}`,
            thumb: `${axios.defaults.baseURL}/resources/${cli}/logo/thumbs/${logoName}`,
        };
    }

    async makeIconeImageURL() {
        const cli = getLocation();
        const url = `${axios.defaults.baseURL}/resources/${cli}/icone/favicon.png`;
        
        try {
            await axios.head(url);
            return url;
        } catch {
            return '';
        }
    }
}

export default new ImageService();